import permission from './module/permisson';

const directives = {
  permission,
};

export default directives;
